(() => {
  const formSelector = '[data-carson-consultation-form]';

  const showStatus = (form, type, message) => {
    const status = form.querySelector('[data-carson-consultation-status]');
    if (!status) return;

    status.textContent = message;
    status.classList.toggle('is-success', type === 'success');
    status.classList.toggle('is-error', type === 'error');
    status.setAttribute('role', type === 'error' ? 'alert' : 'status');
    status.hidden = false;
  };

  const clearStatus = (form) => {
    const status = form.querySelector('[data-carson-consultation-status]');
    const emailInput = form.querySelector('input[type="email"]');
    if (!status) return;

    status.hidden = true;
    status.textContent = '';
    status.classList.remove('is-success', 'is-error');
    status.setAttribute('role', 'status');
    emailInput?.removeAttribute('aria-invalid');
  };

  const subscribe = async (form) => {
    const emailInput = form.querySelector('input[type="email"]');
    const submitButton = form.querySelector('button[type="submit"]');
    const publicKey = form.dataset.klaviyoPublicKey?.trim();
    const listId = form.dataset.klaviyoListId?.trim();
    const successMessage = form.dataset.successMessage || 'Thank you for subscribing.';
    const errorMessage = form.dataset.errorMessage || 'We could not subscribe you. Please try again.';
    const loadingLabel = form.dataset.loadingLabel || 'Subscribing...';

    if (!emailInput || !submitButton || !publicKey || !listId) {
      showStatus(form, 'error', errorMessage);
      return;
    }

    const originalButtonLabel = submitButton.textContent;
    clearStatus(form);
    submitButton.disabled = true;
    submitButton.setAttribute('aria-busy', 'true');
    submitButton.textContent = loadingLabel;

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-07-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: emailInput.value.trim(),
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED',
                          },
                        },
                      },
                    },
                  },
                },
                custom_source: 'Carson homepage newsletter',
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        }
      );

      if (!response.ok) throw new Error(`Klaviyo subscription failed with status ${response.status}`);

      form.reset();
      showStatus(form, 'success', successMessage);
    } catch (error) {
      console.error(error);
      emailInput.setAttribute('aria-invalid', 'true');
      showStatus(form, 'error', errorMessage);
    } finally {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
      submitButton.textContent = originalButtonLabel;
    }
  };

  const initForm = (form) => {
    if (!form || form.dataset.carsonConsultationInitialized === 'true') return;
    form.dataset.carsonConsultationInitialized = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      subscribe(form);
    });
  };

  const initForms = (root = document) => {
    if (root.matches?.(formSelector)) initForm(root);
    root.querySelectorAll?.(formSelector).forEach(initForm);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initForms());
  } else {
    initForms();
  }

  document.addEventListener('shopify:section:load', (event) => initForms(event.target));
})();
